import React, { Component } from 'react';
import axios from 'axios';
import $ from "jquery";
import CajaMusica from "./CajaMusica";
import "./../styles/PagMusicStyle.css";
import "./../styles/formTextItem.css";
import AudioService from "../services/Audio.service";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const sortById = (array) => {
    array.sort(function(a, b){
        let comparison = 0;
        if (a.id < b.id) {
          comparison = 1;
        } else if (a.id  > b.id) {
          comparison = -1;
        }
        return comparison;
    });

    return array;
}

export default class Reproductor extends Component {
    state = {
        title: "",
        audio: "",
        thumbnail: "",
        musics: [],
        firstTime: true,
        loading: true
    }
    updateTitle = (e) => {
        this.setState({title: e.target.value});
    };
    updateAudio = (e) => {
        this.setState({audio: e.target.files[0], title: e.target.files[0].name.slice(0, 50)});
    };
    updateThumbnail = (e) => {
        this.setState({thumbnail: e.target.files[0]});
    };

    addAudioHandler = async (e) => {
        e.preventDefault();

        if(this.state.audio.size >= 30000000){
            alert("El audio es muy grande. Debe pesar menos de 30Mb");
        }
        else{
            var data = new FormData();
            data.append("audio", this.state.audio);
            data.append("thumbnail", this.state.thumbnail);
            data.append("title", this.state.title);
            const response = await AudioService.post(data);

            if(response.data.message === 'POST_AUDIO_SUCCESSFUL'){
                const formAudio = {
                    id: response.data.audio.id,
                    title: response.data.audio.title,
                    path: response.data.audio.path,
                    originalName: response.data.audio.originalName,
                    pauseSwitch: false,
                    thumbnail: {
                        id: response.data.audio.thumbnail.id,
                        path: response.data.audio.thumbnail.path,
                        originalName: response.data.audio.thumbnail.originalName
                    }
                }
                let newAudios = this.state.musics;
                newAudios.push(formAudio);  
                newAudios = sortById(newAudios);
                this.setState({musics: newAudios});
            }
            else{
                alert(`Error: ${response.data.message}`);
            }
        }
    }
    deleteAudioHandler = async (index) => {
        const data = {
            audioUUID: this.state.musics[index].UUID,
            audioPath: this.state.musics[index].path,
            thumbnailUUID: this.state.musics[index].thumbnail.UUID,
            thumbnailPath: this.state.musics[index].thumbnail.path,
        }
        const response = await AudioService.delete(data);
        
        if(response.data.message === 'DELETE_AUDIO_SUCCESSFUL') {
            let newMusics = this.state.musics;
            newMusics.splice(index, 1);
            this.setState({musics: newMusics});
        } else {
            alert(`Error: ${response.data.message}`);
        }
    }

    async componentDidMount(){
        $('#ModalForMusic').css('display', 'block');
        $('#ModalForMusic').hide();

        //Sobre el funcionamiento del modal
        $('#OpenModalMusic').click(function(){
            $('#ModalForMusic').fadeIn();
            $('body').css('overflow-y', 'hidden');
        });

        function closeModal(){
            $('#ModalForMusic').fadeOut(function(){
                $('#textAreaModal').val('');
                $('#textAreaModal').css('height', '100px');
                $('#CharacterCounter').html('0/50');
                $('#fileName').text('');
                $('#musicFile').val('');
                $('#thumbnailFile').val('');
            });
            $('body').css("overflow-y", "auto");
        }
        $('#CloseModalA').click(function(){
            closeModal();
        });
        $('#CloseModalB').click(function(){
            closeModal();
        });

        //Sobre el funcionamiento del textarea
        function textCounter(){
            $('#CharacterCounter').html($(this).val().length+'/50');

            if($(this).val().length === 50){
                $('#CharacterCounter').css('color', '#e43636');
            }else{
                $('#CharacterCounter').css('color', 'rgba(0,0,0,0.87)');
            }
        }
        $('#textAreaModal').keyup(textCounter);
        $('#textAreaModal').keydown(textCounter);

        $('#textAreaModal').each(function () {
            this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
          }).on('input', function () {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
          });

        //Sobre el funcionamiento del Input File
        $('#musicFile').change(function (e){
            var fileName=e.target.files[0].name;
            if(fileName<40){
                $('#fileName').text(fileName);
            }
            else{
                $('#fileName').text(fileName.substr(0, 27)+"..."+fileName.substr(fileName.length-10, fileName.length));
            }
        });
        $('#thumbnailFile').change(function (e){
            var fileName=e.target.files[0].name;
            if(fileName<40){
                $('#fileName1').text(fileName);
            }
            else{
                $('#fileName1').text(fileName.substr(0, 27)+"..."+fileName.substr(fileName.length-10, fileName.length));
            }
        });

        const response = await axios.get(`${SERVER_URL}/api/isLoggedIn`, { withCredentials: true });
        this.setState({ isLoggedIn: response.data.isLoggedIn, firstTime: false });

        if(response.data.isLoggedIn){
            const response = await AudioService.get();
            if(response.status !== 200){
                alert(`Error: ${response.data.message}`);
            } else {
                response.data.audios = response.data.audios.map((audio) => {
                    audio.pauseSwitch = false;
                    return audio;
                });

                this.setState({ loading: false, musics: response.data.audios });
            }
        }
    }

    stopAllAudiosHandler = (id) => { //++++++++++
        const updatedMusics = this.state.musics.map(music => {
            return {
                ...music,
                pauseSwitch: (music.id !== id) ? !music.pauseSwitch : music.pauseSwitch
            }
        });
        this.setState({musics: updatedMusics});
    }

    render() {
        var dataReturn;
        if(this.state.musics.length>0){
            dataReturn=<div className="grillaMusica"><div className="backgroundBox">
                {
                    this.state.musics.map((music, index) => {
                        return <CajaMusica
                            key={index}
                            index={index}
                            musicUUID={music.UUID}
                            musicOriginalName = {music.originalName}
                            musicPath={SERVER_URL + music.path}
                            title={music.title}
                            musicImage={SERVER_URL + music.Thumbnail.path}
                            pauseSwitch={music.pauseSwitch}
                            stopOtherSounds={this.stopAllAudiosHandler}
                            onDelete={this.deleteAudioHandler}
                        />
                    })
                }
            </div></div>
        }else{
            dataReturn=<p className="notFound">No hay ninguna música o canción para escuchar, comience agregando una.</p>
        }
        var dataLoader=<div className="LoadingContainer">
            <div className="loader"></div>    
        </div>

        return (
            <div className="card formTextItem">
                <h1>Mi biblioteca musical</h1>
                <p className="description">
                    Crea tu propia biblioteca de canciones que te relajen, generen sensaciones placenteras, te provoquen 
                    buenos recuerdos, o que te distraigan.
                </p>
                <div className="ButtonAdd">
                    <button className="btn" id={'OpenModalMusic'}><i className="material-icons-round prefix">add</i>Agregar otra música</button>
                </div>
                <div className="modal" id={'ModalForMusic'} action="">
                    <div className="modalContent">
                        <form action="" className="card">
                            <div className="body-card">
                                <div className="TextAreaCard">
                                    <textarea onChange={this.updateTitle} value={this.state.title} id={'textAreaModal'} maxLength="50" placeholder="Escribe el nombre acá..."></textarea>
                                    <p className="CharacterCounter" id={'CharacterCounter'}>0/50</p>
                                </div>
                                <div className="uploadMusic">
                                    <input type="file" id={'musicFile'} name="musicFile" onChange={this.updateAudio} accept="audio/*"/>
                                    <label htmlFor="musicFile" className="uploadButton">
                                        <div className="btn">Seleccionar música</div>
                                        <div className="fileNameContainer">
                                            <p id={'fileName'}>...</p>
                                        </div>
                                    </label>
                                    <input type="file" id={'thumbnailFile'} name="thumbnailFile" onChange={this.updateThumbnail} accept="image/*"/>
                                    <label htmlFor="thumbnailFile" className="uploadButton">
                                        <div className="btn">Seleccionar portada</div>
                                        <div className="fileNameContainer">
                                            <p id={'fileName1'}>...</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div className="end-card confirmFooter">
                                <div id={'CloseModalB'}>CANCELAR</div>
                                <button id={'CloseModalA'} className="btn" onClick={this.addAudioHandler}>LISTO</button>
                            </div>
                        </form>
                    </div>
                </div>

                {this.state.loading ? dataLoader : dataReturn}
            </div>
        )
    }
}